import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadPackagesPriceRangeRequestDto as RequestDto,
  ReadPackagesPriceRangeResponseDto as ResponseDto,
} from "../../api/packages/priceRange/dtos";
import { Api } from "../../api";
import { Package } from "../../models";
import format from "date-fns/format";
import dinero, { Dinero } from "dinero.js";
import { prepPrice } from "../../../utils";

interface Data {
  [packageId: number]: {
    min: Dinero;
    max: Dinero;
  };
}
interface CallParams {
  packages: Package[];
  personTypes: { id: number; quantity: number; name: string }[];
  dates: Date[];
}
export const priceRanges = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "PACKAGES_PRICE_RANGES",
  Api.packages.readPriceRanges,
  ({ data: { data } }) => {
    return data.reduce(
      (acc, { model_id, max, min }) => ({
        ...acc,
        [model_id]: {
          min: dinero({ amount: prepPrice(min) }),
          max: dinero({ amount: prepPrice(max) }),
        },
      }),
      {}
    );
  },
  ({ packages, personTypes, dates }) => ({
    ids: packages.map(({ id }) => id),
    person_types: personTypes.map(({ id }) => id),
    dates: dates.map((date) => format(date, "yyyy-MM-dd")),
  })
);
